// 고객용 페이지네이션 컴포넌트

import React, { useState } from 'react';

function Pagination({ count, page, setPage, handlePrevPage, handleNextPage }) {
  const totalPages = Math.ceil(count / 10);
  const [visiblePages, setVisiblePages] = useState([]);

  const renderPageNumbers = () => {
    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }

    if (totalPages <= 10) {
      return pageNumbers.map((pg) => (
        <li
          key={pg}
          className={pg === page ? 'cur' : ''}
          onClick={() => setPage(pg)}
        >
          {pg}
        </li>
      ));
    } else {
      let displayedPages = [];
      if (page <= 6) {
        displayedPages = [...pageNumbers.slice(0, 7), '...', totalPages];
      } else if (page >= totalPages - 5) {
        displayedPages = [1, '...', ...pageNumbers.slice(totalPages - 7)];
      } else {
        displayedPages = [1, '...', ...pageNumbers.slice(page - 4, page + 2), '...', totalPages];
      }

      return displayedPages.map((pg) => (
        <li
          key={pg}
          className={pg === page ? 'cur' : ''}
          onClick={() => {
            if (pg === '...') return;
            setPage(pg);
          }}
        >
          {pg === '...' ? pg : <span>{pg}</span>}
        </li>
      ));
    }
  };

  return (
    <ul className="m-page-nav-btn s">
      <button onClick={handlePrevPage} disabled={page === 1}>
        <i className="xi-angle-left"></i>
      </button>
      {renderPageNumbers()}
      <button onClick={handleNextPage} disabled={page === totalPages}>
        <i className="xi-angle-right"></i>
      </button>
    </ul>
  );
}

export default Pagination;
